import { useStore as getStore } from "../../utils/useStore.js";
import uploaderFactory from "./uploaderFactory.js";

const initialState = () => ({
  uploader: null,
  server: false,
  uploading: false,
  size: null,
  openUploader: false,
  uplodaerAPI: "fine",
  videoDuration: 0,
  allowedVideoDuration: 0,
  spamProtection: {
    link: false,
    mail: true,
  },
  verifyingProcess: {
    time: null,
    sessionId: null,
  },
});

const [UploaderProvider, useUploader, withUploader] = getStore(
  uploaderFactory,
  initialState,
  "Uploader"
);

export const uploaderInitState = initialState();

export { useUploader, UploaderProvider, withUploader };

export default UploaderProvider;
